import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles(({ colors, breakpoints }: Theme) => createStyles({
  menuWrapper: {
    borderBottom: `1px solid ${colors.border}`,
  },
  filterButton: {
    height: 36,
    minWidth: 36,
    marginBottom: 6,
    color: '#747C99',
    background: '#F1F2F5',
    borderRadius: 18,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background 0.2s, color 0.2s',
    cursor: 'pointer',
    userSelect: 'none',

    '&:hover': {
      background: '#e0e1e4',
    },
  },
  filterButtonActive: {
    color: '#FFFFFF',
    background: '#01B3C5',

    '&:hover': {
      background: '#01a0b2',
    },
  },
  filterButtonWithFilters: {
    padding: 12,
  },
  counter: {
    marginLeft: 14,
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'Montserrat',
  },
  filterPanel: {
    width: 440,
    maxWidth: '100%',
    border: `1px solid ${colors.border}`,
    fontSize: 14,
    fontWeight: 700,
    fontFamily: 'Montserrat',
    marginTop: 13,
  },
  header: {
    minHeight: 44,
    padding: 8,
    borderBottom: '1px solid #DCDEE5',
  },
  content: {
    display: 'flex',
    width: '100%',
    // flexWrap: 'nowrap',
    overflowX: 'auto',
  },
  leftContent: {
    width: '50%',
    padding: 8,
    borderRight: '1px solid #DCDEE5',
    maxHeight: 350,
    overflowY: 'auto',
  },
  rightContent: {
    width: '50%',
    padding: 8,
  },
  bottom: {
    padding: 8,
    borderTop: '1px solid #DCDEE5',
  },
  buttonIcon: {

  },
  paper: {
    width: '100%',
  },
  popper: {
    position: 'fixed',
    maxWidth: '100%',
    margin: '0 auto',
  },
}));

export default useStyles;
